import LiteTradeSelectAccount
    from '../../../modules/LiteTrade/components/LiteTradeSelectAccount/LiteTradeSelectAccount';
import React, { useCallback } from 'react';
import { FormGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FEATURES } from '../../../app/appConstants';
import { getAppFeatures, getAppUser, getUserSelectedAccountCode, } from '../../../app/appSelectors';
import { MobileAccountBoxHeaderButtonSkeletonStyled, } from './styled/MobileAccountBoxStyled';
import {
    LiteTradeSelectAccountStyled,
} from '../../../modules/LiteTrade/components/LiteTradeSelectAccount/styled/LiteTradeSelectAccountStyled';
import UserStatusCircleProgress from "../../../modules/UserStatus/UserStatusCircleProgress/UserStatusCircleProgress";
import useSelectAccountsHandlers
    from '../../../modules/LiteTrade/components/LiteTradeSelectAccount/hooks/useSelectAccountsHandlers';
import { locationSlice } from '../../../modules/Location/locationReducer';
import { LOCATION_NAMES } from '../../../modules/Location/locationConstants';
import LiteTradeSelectAccountToggle2
    from "../../../modules/LiteTrade/components/LiteTradeSelectAccount/LiteTradeSelectAccountToggle2";
import type { IAccountType } from "../../../app/types/appActions.t";
import { TSliderToggleComponent } from "../../../components/Slider/Slider";

interface IMobileAccountBoxHeaderProps {
    getSelectAccountToggleComponent?: (
        onClick: (event: any) => void,
        selectedAccount: { accountCode: string, type: IAccountType },
        disabled: boolean
    ) => TSliderToggleComponent,
}

function MobileAccountBoxHeader(props: IMobileAccountBoxHeaderProps) {
    const dispatch = useDispatch();
    const accountCode = useSelector(getUserSelectedAccountCode);
    const features = useSelector(getAppFeatures);
    const user = useSelector(getAppUser);
    const { handleAccountSelectClose, handleAccountSelectClick } = useSelectAccountsHandlers();

    const handleUserStatusClick = useCallback(() => {
        dispatch(locationSlice.actions.openLocationAction({ name: LOCATION_NAMES.USER_STATUSES }));
    }, [dispatch]);

    const getSelectAccountToggleComponent = useCallback((
        onClick: (event: any) => void,
        selectedAccount: { accountCode: string, type: IAccountType },
        disabled: boolean
    ) => {
        if (typeof props.getSelectAccountToggleComponent === 'function') {
            return props.getSelectAccountToggleComponent(onClick, selectedAccount, disabled);
        }
        return <LiteTradeSelectAccountToggle2
            onClick={onClick}
            type={selectedAccount.type}
            disabled={disabled}/>;
    }, [props]);

    if (!accountCode) {
        return (
            <FormGroup className={'mb-3 d-flex justify-content-between'}>
                <div>
                    <LiteTradeSelectAccountStyled className='wave-background min-width'/>
                </div>
                <div className={'f24'}>
                    <MobileAccountBoxHeaderButtonSkeletonStyled className='wave-background'/>
                </div>
            </FormGroup>
        );
    }

    return (
        <FormGroup className={'MobileAccountBoxHeader mb-3 d-flex justify-content-between'}>
            {
                !features[FEATURES.DEMO_MODE] && <LiteTradeSelectAccount
                    onSelectAccountClick={handleAccountSelectClick}
                    onSelectAccountClose={handleAccountSelectClose}
                    getToggleComponent={getSelectAccountToggleComponent}
                />
            }
            {
                features[FEATURES.USER_STATUSES] &&
                <div onClick={handleUserStatusClick}>
                    <UserStatusCircleProgress
                        size={37}
                        isShowUpdatedProgressAnimation
                        progress={user.user_turnover_percent}
                        userStatus={user.user_status}/>
                </div>
            }
        </FormGroup>
    );
}

export default MobileAccountBoxHeader;
